export const DAILY_WORKING_HOURS_OPTIONS = Object.freeze([
  { value: 8, label: '8' },
  { value: 12, label: '12' },
  { value: 16, label: '16' }
])

export const WEEKLY_WORKING_HOURS_OPTIONS = Object.freeze([
  { value: 40, label: '40' },
  { value: 60, label: '60' },
  { value: 84, label: '84' }
])

export const CUSTOM_WEEKLY_WORKING_HOURS = 'custom'

export function normalizePaymentType(paymentType) {
  return typeof paymentType === 'string' ? paymentType.toLowerCase() : ''
}

export function isWorkingHoursPaymentType(paymentType) {
  return ['employee', 'contractor'].includes(normalizePaymentType(paymentType))
}

export function getDailyWorkingHoursOptions() {
  return DAILY_WORKING_HOURS_OPTIONS
}

export function getWeeklyWorkingHoursSelectValue(value) {
  const numericValue = Number(value)

  if (!Number.isFinite(numericValue)) {
    return undefined
  }

  if (WEEKLY_WORKING_HOURS_OPTIONS.some(option => option.value === numericValue)) {
    return numericValue
  }

  return numericValue > 0 ? CUSTOM_WEEKLY_WORKING_HOURS : undefined
}
